var render = function render(){var _vm=this,_c=_vm._self._c;return _c('auth-layout',[_c('div',{staticClass:"centered unauthorized-container"},[_c('h1',[_vm._v("Unauthorized")]),_c('h4',[_vm._v("You are not authorized to view this page.")]),_c('router-link',{attrs:{"to":"/login"}},[_c('h4',[_vm._v("Go to Login Page")])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }